import React from 'react';
import './AddPointsComponent.css';
import { Apiurl } from '../../../Pages/utils/page';

const AddPointsComponent = ({ handleAddPointSlab, handleImageUpload,
    formData, setFormData, pointSLabData


}) => {
    return (
        <div className="banner_section" style={{ flex: "1" }}>
            <div className="container">
                <div className="row">
                <h4 className="common_heading">Add Points</h4>

                    <div className="col-lg-12 mb_commn_pd_0">
                        <div className="pointAddSection">
                            <div className="Cus_shadow">
                                <form className="form">
                                    <div className="row">
                                        <div className="col-lg-3 col-sm-6">
                                            <div className="form-group">
                                                <label className="required-label">Money</label>
                                                <input className="form-control" type="text" name="RewardName"
                                                    value={formData?.money}

                                                    onChange={(e) => { setFormData({ ...formData, money: e?.target.value }) }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-sm-6">
                                            <div className="form-group">
                                                <label className="required-label">Points</label>
                                                <input className="form-control" type="text" name="RewardPoint"
                                                    value={formData?.points}
                                                    onChange={(e) => { setFormData({ ...formData, points: e?.target.value }) }}

                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-sm-6 col-12">
                                            <div className="form-group">
                                                <div className="row">
                                                    <div className="col-lg-12 col-12">
                                                        <label className="required-label">Reward Image</label>
                                                        <input
                                                            id="image-upload"
                                                            className="form-control custom-file-input"
                                                            accept="image/png, image/jpeg, image/gif"
                                                            type="file"
                                                            onChange={handleImageUpload}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </form>
                                <div className="col-lg-3 col-sm-6 col-12">
                                    <button type="button" className="common_btn btn btn-primary common_btn_pd" onClick={handleAddPointSlab}>Add</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="promocode_table">
                    <div className="row">
                        <div className="col-lg-12 mb_commn_pd_0">
                            <div className="table-responsive table-sm custom-table">
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Image</th>
                                            <th>Money</th>
                                            <th>Points</th>
                                            <th>Action</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pointSLabData?.map((item, index) => {
                                            const image = item?.Image?.split('"')
                                            const imageURL = `${Apiurl()}/${image?.[1]}`
                                            return (
                                                <tr>
                                                    <td>{index + 1}</td>
                                                    <td>
                                                        <img
                                                            src={imageURL}
                                                            alt="Reward Image"
                                                            style={{ maxHeight: '50px', maxWidth: '50px' }}
                                                        />
                                                    </td>
                                                    <td>{item?.Money}</td>
                                                    <td>{item?.Points}</td>

                                                    <td className="reff_center_tb_wdt">
                                                        <button type="button" className="common_btn btn-primary">Edit</button>
                                                        <button type="button" className="common_btn btn-danger">Delete</button>
                                                    </td>
                                                </tr>
                                            )
                                        })}

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddPointsComponent;
